module.exports = __webpack_public_path__ + "img/photo-0015.e375a9e0.jpg";